/*@ngInject*/
const RewriteSubmissionRepository = function (baseRepository, submissionCopyOptions, notificationConstant) {

    angular.extend(this, baseRepository);

    this.rewriteSubmission = function (submissionId, reason, detail, effectiveDate, expirationDate, copyOptions) {
        var url = '/rest/Submission/' + submissionId + '/rewrite',
            config = {
                params: {
                    reason: reason,
                    detail: detail,
                    rewriteEffectiveDate: moment.utc(effectiveDate).format('YYYY-MM-DD'),
                    rewriteExpirationDate: moment.utc(expirationDate).format('YYYY-MM-DD'),
                    rewriteOptions: copyOptions,
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('rewriteSubmissionRepository', RewriteSubmissionRepository);
